var _filter, _clipPath, _clipPath2, _clipPath3, _clipPath4, _g, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9, _clipPath10, _clipPath11, _g2, _clipPath12, _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWelcomeVetor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "280px",
    height: "246px",
    viewBox: "0 0 140 123",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 118.782,
    y1: -217.393,
    x2: 221.055,
    y2: 417.12,
    gradientTransform: "matrix(0.5,0,0,0.5,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(4.313725%,13.333333%,36.078431%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(58.039216%,72.54902%,100%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 169.294,
    y1: 132.822,
    x2: 176.287,
    y2: 229.639,
    gradientTransform: "matrix(0.5,0,0,0.5,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(100%,100%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(58.039216%,72.54902%,100%)",
      stopOpacity: 1
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "alpha",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    in: "SourceGraphic",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 140,
    height: 123,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.701961,
      stroke: "none"
    }
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 140,
    height: 123
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface5",
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,0%,41.960784%)",
      fillOpacity: 1
    },
    d: "M 2.785156 4.984375 C 7.789062 9.25 20.976562 18.96875 37.722656 19.429688 C 38.066406 19.441406 38.390625 19.585938 38.628906 19.832031 C 38.867188 20.078125 39 20.40625 39 20.75 L 39 47.273438 C 39 47.609375 38.871094 47.933594 38.636719 48.179688 C 38.40625 48.425781 38.085938 48.570312 37.746094 48.589844 C 32.710938 48.839844 13.617188 48.808594 0.960938 35.269531 C 0.738281 35.027344 0.613281 34.707031 0.613281 34.375 L 0.613281 5.992188 C 0.613281 5.738281 0.683594 5.492188 0.820312 5.28125 C 0.957031 5.066406 1.148438 4.898438 1.378906 4.792969 C 1.605469 4.6875 1.863281 4.648438 2.109375 4.683594 C 2.359375 4.71875 2.59375 4.824219 2.785156 4.984375 Z M 2.785156 4.984375 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 140,
    height: 123,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.4,
      stroke: "none"
    }
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 140,
    height: 123
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface8",
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 9 35 C 9 35 19.984375 45.242188 34.273438 49.039062 ",
    transform: "matrix(0.5,0,0,0.5,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 140,
    height: 123,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.701961,
      stroke: "none"
    }
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 140,
    height: 123,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.701961,
      stroke: "none"
    }
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 140,
    height: 123
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface12",
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(4.313725%,13.333333%,36.078431%)",
      fillOpacity: 1
    },
    d: "M 12.515625 59.945312 C 17.519531 63.613281 30.707031 73.191406 47.453125 71.671875 C 47.617188 71.652344 47.78125 71.667969 47.9375 71.71875 C 48.09375 71.765625 48.238281 71.851562 48.359375 71.960938 C 48.480469 72.070312 48.578125 72.207031 48.640625 72.359375 C 48.703125 72.507812 48.734375 72.671875 48.730469 72.835938 L 48.730469 99.359375 C 48.722656 99.710938 48.59375 100.046875 48.363281 100.316406 C 48.136719 100.582031 47.824219 100.761719 47.476562 100.824219 C 42.441406 101.671875 21.496094 101.253906 10.691406 90.445312 C 10.582031 90.332031 10.492188 90.199219 10.433594 90.054688 C 10.371094 89.90625 10.34375 89.75 10.34375 89.59375 L 10.34375 61.207031 C 10.34375 60.082031 11.660156 59.316406 12.515625 59.945312 Z M 12.515625 59.945312 "
  })), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 140,
    height: 123
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surface14",
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface12",
    mask: "url(#mask3)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 140,
    height: 123,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.701961,
      stroke: "none"
    }
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 140,
    height: 123
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface17",
    clipPath: "url(#clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,0%,41.960784%)",
      fillOpacity: 1
    },
    d: "M 133.550781 62.101562 C 126.574219 68.046875 108.179688 81.601562 84.816406 82.25 C 84.339844 82.265625 83.886719 82.464844 83.550781 82.808594 C 83.21875 83.148438 83.035156 83.609375 83.035156 84.085938 L 83.035156 121.085938 C 83.035156 121.554688 83.214844 122.011719 83.542969 122.351562 C 83.867188 122.695312 84.3125 122.898438 84.785156 122.921875 C 91.808594 123.269531 118.445312 123.230469 136.09375 104.34375 C 136.410156 104.003906 136.585938 103.558594 136.582031 103.097656 L 136.582031 63.5 C 136.582031 63.152344 136.480469 62.808594 136.292969 62.511719 C 136.101562 62.214844 135.832031 61.980469 135.515625 61.832031 C 135.195312 61.683594 134.839844 61.632812 134.492188 61.679688 C 134.144531 61.726562 133.816406 61.871094 133.550781 62.101562 Z M 133.550781 62.101562 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 140,
    height: 123,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.4,
      stroke: "none"
    }
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 140,
    height: 123
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface20",
    clipPath: "url(#clip6)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 261.804688 158.976562 C 261.804688 158.976562 246.484375 173.257812 226.554688 178.5625 ",
    transform: "matrix(0.5,0,0,0.5,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 140,
    height: 123,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.701961,
      stroke: "none"
    }
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 140,
    height: 123
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface23",
    clipPath: "url(#clip7)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,0%,41.960784%)",
      fillOpacity: 1
    },
    d: "M 2.398438 110.996094 L 18.453125 110.996094 C 18.765625 110.996094 19.078125 110.933594 19.371094 110.8125 C 19.660156 110.695312 19.925781 110.515625 20.148438 110.292969 C 20.371094 110.070312 20.546875 109.808594 20.667969 109.515625 C 20.789062 109.226562 20.851562 108.914062 20.851562 108.601562 L 20.851562 103.636719 C 20.851562 103.320312 20.789062 103.007812 20.667969 102.71875 C 20.546875 102.429688 20.371094 102.164062 20.148438 101.941406 C 19.925781 101.71875 19.660156 101.542969 19.371094 101.421875 C 19.078125 101.300781 18.765625 101.238281 18.453125 101.238281 L 12.753906 101.238281 L 11.070312 99.558594 C 10.914062 99.402344 10.699219 99.3125 10.476562 99.3125 C 10.253906 99.3125 10.042969 99.402344 9.882812 99.558594 L 8.203125 101.238281 L 2.398438 101.238281 C 1.761719 101.238281 1.152344 101.492188 0.703125 101.941406 C 0.253906 102.390625 0 103 0 103.636719 L 0 108.601562 C 0 109.234375 0.253906 109.84375 0.703125 110.292969 C 1.152344 110.742188 1.761719 110.996094 2.398438 110.996094 Z M 2.398438 110.996094 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 140,
    height: 123,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.701961,
      stroke: "none"
    }
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 97.5066,
    y1: 182.631,
    x2: 106.551,
    y2: 282.409,
    gradientTransform: "matrix(0.5,0,0,0.5,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(100%,100%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(58.039216%,72.54902%,100%)",
      stopOpacity: 1
    }
  })), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 140,
    height: 123
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface26",
    clipPath: "url(#clip8)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear2)"
    },
    d: "M 37.464844 91.425781 C 41.292969 92.515625 50.246094 94.46875 61.976562 93.121094 C 62.164062 93.097656 62.355469 93.109375 62.539062 93.164062 C 62.722656 93.21875 62.890625 93.316406 63.03125 93.441406 C 63.175781 93.566406 63.289062 93.722656 63.363281 93.898438 C 63.441406 94.070312 63.476562 94.261719 63.472656 94.449219 L 63.472656 112.546875 C 63.464844 112.945312 63.316406 113.328125 63.050781 113.628906 C 62.789062 113.929688 62.425781 114.128906 62.03125 114.1875 C 57.855469 114.757812 45.453125 115.976562 36.207031 111.988281 C 35.972656 111.886719 35.773438 111.714844 35.632812 111.496094 C 35.496094 111.277344 35.425781 111.023438 35.429688 110.765625 L 35.429688 93.027344 C 35.429688 91.976562 36.488281 91.148438 37.464844 91.425781 Z M 37.464844 91.425781 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 140,
    height: 123,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.4,
      stroke: "none"
    }
  }))), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 140,
    height: 123
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface29",
    clipPath: "url(#clip9)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 67.5 178.898438 L 79.039062 181.09375 ",
    transform: "matrix(0.5,0,0,0.5,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 140,
    height: 123,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.701961,
      stroke: "none"
    }
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 140,
    height: 123,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.701961,
      stroke: "none"
    }
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear3",
    gradientUnits: "userSpaceOnUse",
    x1: 232.348,
    y1: -108.371,
    x2: 289.837,
    y2: 191.666,
    gradientTransform: "matrix(0.5,0,0,0.5,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(100%,100%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(4.313725%,13.333333%,36.078431%)",
      stopOpacity: 1
    }
  })), _clipPath10 || (_clipPath10 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 140,
    height: 123
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface33",
    clipPath: "url(#clip11)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear3)"
    },
    d: "M 137.824219 2.886719 C 132.824219 6.558594 123.675781 15.8125 103.710938 18.886719 C 102.179688 19.121094 101.609375 20.207031 101.609375 21.410156 L 101.609375 46.707031 C 101.617188 47.058594 101.746094 47.394531 101.976562 47.664062 C 102.203125 47.929688 102.515625 48.109375 102.863281 48.171875 C 107.898438 49.019531 127.292969 44.078125 138.890625 34.121094 C 139.996094 33.171875 139.996094 31.578125 139.996094 31.246094 L 139.996094 4.148438 C 139.996094 3.027344 138.679688 2.261719 137.824219 2.886719 Z M 137.824219 2.886719 "
  })), _clipPath11 || (_clipPath11 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 140,
    height: 123
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "surface35",
    clipPath: "url(#clip10)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface33",
    mask: "url(#mask10)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 140,
    height: 123,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.6,
      stroke: "none"
    }
  }))), _clipPath12 || (_clipPath12 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 140,
    height: 123
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface38",
    clipPath: "url(#clip12)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(4.313725%,13.333333%,36.078431%)",
      fillOpacity: 1
    },
    d: "M 113.65625 32.664062 L 116.21875 35.378906 C 116.300781 35.46875 116.40625 35.527344 116.523438 35.554688 C 116.640625 35.582031 116.761719 35.570312 116.875 35.527344 C 117.628906 35.234375 119.328125 34.566406 120.191406 34.195312 C 120.296875 34.148438 120.390625 34.070312 120.453125 33.972656 C 120.519531 33.875 120.554688 33.761719 120.554688 33.644531 L 120.554688 31.097656 C 120.554688 30.96875 120.511719 30.84375 120.433594 30.738281 L 116.832031 25.917969 C 116.765625 25.832031 116.679688 25.761719 116.582031 25.722656 C 116.480469 25.679688 116.371094 25.667969 116.265625 25.683594 C 116.160156 25.695312 116.058594 25.742188 115.972656 25.808594 C 115.890625 25.875 115.824219 25.964844 115.785156 26.066406 L 113.53125 32.039062 C 113.492188 32.144531 113.480469 32.257812 113.503906 32.371094 C 113.527344 32.480469 113.578125 32.582031 113.65625 32.664062 Z M 113.65625 32.664062 "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(4.313725%,13.333333%,36.078431%)",
      fillOpacity: 1
    },
    d: "M 28.042969 0 L 113.769531 0 C 115.066406 0 116.308594 0.515625 117.226562 1.429688 C 118.140625 2.347656 118.65625 3.589844 118.65625 4.882812 L 118.65625 10.277344 L 23.15625 10.277344 L 23.15625 4.882812 C 23.15625 3.589844 23.671875 2.347656 24.585938 1.429688 C 25.503906 0.515625 26.746094 0 28.042969 0 Z M 28.042969 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 23.15625 10.28125 L 118.65625 10.28125 L 118.65625 96.796875 C 118.65625 97.96875 118.425781 99.128906 117.976562 100.210938 C 117.527344 101.296875 116.871094 102.28125 116.039062 103.109375 C 115.210938 103.9375 114.222656 104.597656 113.140625 105.046875 C 112.054688 105.492188 110.894531 105.722656 109.722656 105.722656 L 32.089844 105.722656 C 30.917969 105.722656 29.753906 105.492188 28.671875 105.046875 C 27.585938 104.597656 26.601562 103.9375 25.773438 103.109375 C 24.945312 102.28125 24.285156 101.296875 23.835938 100.210938 C 23.386719 99.128906 23.15625 97.96875 23.15625 96.796875 Z M 23.15625 10.28125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,70.196078%)",
      fillOpacity: 1
    },
    d: "M 85.554688 71.648438 L 59.359375 71.648438 L 59.359375 84.363281 L 85.554688 84.363281 Z M 85.554688 71.648438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(5.490196%,6.27451%,15.294118%)",
      fillOpacity: 1
    },
    d: "M 59.203125 79.488281 C 56.132812 82.507812 54.921875 97.382812 55.085938 105.722656 L 91.652344 105.722656 C 91.652344 105.722656 91.585938 87.539062 88.816406 81.414062 C 86.265625 75.777344 82.027344 84.089844 59.203125 79.488281 Z M 59.203125 79.488281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(4.313725%,13.333333%,36.078431%)",
      fillOpacity: 1
    },
    d: "M 65.25 44.050781 C 65.25 44.050781 69.953125 49.328125 68.390625 51.019531 C 65.289062 54.5 57.046875 61.039062 54.347656 63.203125 C 54.230469 63.292969 54.097656 63.359375 53.957031 63.394531 C 53.8125 63.433594 53.664062 63.441406 53.519531 63.421875 C 53.375 63.402344 53.234375 63.351562 53.109375 63.277344 C 52.980469 63.203125 52.871094 63.105469 52.78125 62.988281 L 46.394531 54.597656 C 46.144531 54.273438 46.03125 53.867188 46.070312 53.460938 C 46.109375 53.054688 46.304688 52.679688 46.613281 52.414062 L 58.984375 41.75 Z M 65.25 44.050781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(5.490196%,6.27451%,15.294118%)",
      fillOpacity: 1
    },
    d: "M 57.820312 50.757812 C 57.820312 50.757812 51.957031 54.238281 51.429688 61.238281 L 52.597656 62.734375 C 52.597656 62.734375 53.332031 64.011719 54.347656 63.199219 C 55.363281 62.386719 60.0625 58.625 60.0625 58.625 Z M 57.820312 50.757812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(4.313725%,13.333333%,36.078431%)",
      fillOpacity: 1
    },
    d: "M 63.300781 53.410156 C 66.960938 53.410156 69.925781 50.445312 69.925781 46.789062 C 69.925781 43.136719 66.960938 40.171875 63.300781 40.171875 C 59.644531 40.171875 56.679688 43.136719 56.679688 46.789062 C 56.679688 50.445312 59.644531 53.410156 63.300781 53.410156 Z M 63.300781 53.410156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,70.196078%)",
      fillOpacity: 1
    },
    d: "M 46.0625 67.539062 L 40.273438 59.878906 L 45.75 55.628906 L 46.609375 54.9375 L 52.613281 62.785156 L 51.570312 63.535156 Z M 46.0625 67.539062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,58.823529%,48.627451%)",
      fillOpacity: 1
    },
    d: "M 51.566406 63.535156 C 50.015625 61.460938 47.101562 57.40625 45.75 55.628906 L 46.609375 54.9375 L 52.597656 62.738281 Z M 51.566406 63.535156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,70.196078%)",
      fillOpacity: 1
    },
    d: "M 43.082031 68.601562 C 45.734375 68.601562 47.886719 66.449219 47.886719 63.796875 C 47.886719 61.144531 45.734375 58.992188 43.082031 58.992188 C 40.425781 58.992188 38.273438 61.144531 38.273438 63.796875 C 38.273438 66.449219 40.425781 68.601562 43.082031 68.601562 Z M 43.082031 68.601562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,70.196078%)",
      fillOpacity: 1
    },
    d: "M 47.148438 61.210938 C 47.148438 61.210938 31.640625 38.449219 30.921875 36.519531 C 30.226562 34.628906 26.5625 39.171875 26.5625 39.171875 L 38.5625 65.34375 Z M 47.148438 61.210938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,70.196078%)",
      fillOpacity: 1
    },
    d: "M 68.496094 29.472656 L 66.632812 42.460938 C 66.632812 42.460938 66.144531 44.183594 68.316406 44.445312 C 70.488281 44.707031 75.117188 44.125 76.773438 42.363281 C 78.425781 40.601562 77.847656 39.726562 77.847656 39.726562 L 74.339844 25.628906 Z M 68.496094 29.472656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,58.823529%,48.627451%)",
      fillOpacity: 1
    },
    d: "M 68.238281 31.152344 L 72.796875 29.539062 L 67.148438 37.910156 Z M 68.238281 31.152344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,70.196078%)",
      fillOpacity: 1
    },
    d: "M 63.335938 13.425781 C 63.335938 13.425781 59.425781 22.613281 61.464844 28.910156 C 62.792969 33.015625 65.6875 33.753906 72.320312 30.675781 C 78.402344 27.855469 79.980469 25.71875 79.980469 25.71875 L 80.878906 15.480469 C 80.878906 15.480469 67.308594 5.238281 63.335938 13.425781 Z M 63.335938 13.425781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(4.313725%,13.333333%,36.078431%)",
      fillOpacity: 1
    },
    d: "M 66.601562 38.726562 C 66.601562 38.726562 61.589844 40.117188 60.574219 40.929688 C 59.558594 41.742188 58.816406 48.351562 57.316406 51.617188 C 55.089844 56.449219 53.648438 59.023438 57.386719 64.332031 C 59.640625 67.535156 58.875 75.679688 58.875 75.679688 L 86.328125 75.679688 C 85.496094 59.667969 89.175781 40.789062 89.175781 40.789062 L 76.789062 37.9375 C 73.992188 38.417969 66.601562 38.726562 66.601562 38.726562 Z M 66.601562 38.726562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(4.313725%,13.333333%,36.078431%)",
      fillOpacity: 1
    },
    d: "M 65.726562 38.984375 C 65.726562 38.984375 66.097656 36.464844 67.28125 36.289062 C 68.464844 36.113281 75.703125 35.023438 76.828125 35.496094 C 77.953125 35.972656 79.316406 38.984375 79.316406 38.984375 C 79.316406 38.984375 77.003906 44.617188 73.6875 44.914062 C 70.371094 45.207031 64.660156 44.1875 65.261719 42.09375 C 65.867188 39.996094 65.726562 38.984375 65.726562 38.984375 Z M 65.726562 38.984375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1.35709,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 126 79.5 C 126 79.5 128.546875 89.210938 137.234375 89.0625 C 145.9375 88.90625 158.5 76.5 158.5 76.5 ",
    transform: "matrix(0.5,0,0,0.5,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(5.490196%,6.27451%,15.294118%)",
      fillOpacity: 1
    },
    d: "M 83.167969 46.789062 C 83.167969 46.789062 78.847656 49.644531 80.117188 52.527344 C 81.550781 55.765625 81.539062 64.105469 77.429688 64.628906 C 70.101562 65.5625 73.285156 66.84375 76.675781 67.660156 C 80.0625 68.480469 78.675781 68.480469 78.675781 71.988281 C 78.675781 74.484375 86.527344 76.652344 86.324219 74.632812 C 84.957031 61.136719 90.632812 52.589844 83.167969 46.789062 Z M 83.167969 46.789062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(90.588235%,28.627451%,36.078431%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(90.588235%,28.627451%,36.078431%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 126 53 L 129.023438 54.335938 L 133.28125 53.359375 C 133.25 53.453125 133.210938 53.570312 133.15625 53.71875 C 133.03125 54.03125 132.828125 54.4375 132.5 54.835938 C 131.851562 55.632812 130.726562 56.382812 128.78125 56.1875 C 127.546875 55.945312 126.851562 55.125 126.453125 54.335938 C 126.257812 53.945312 126.132812 53.570312 126.0625 53.289062 C 126.03125 53.171875 126.015625 53.078125 126 53 Z M 126 53 ",
    transform: "matrix(0.5,0,0,0.5,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 63.230469 20.902344 C 63.382812 20.339844 63.195312 19.796875 62.8125 19.695312 C 62.429688 19.589844 61.996094 19.964844 61.847656 20.527344 C 61.695312 21.09375 61.878906 21.632812 62.261719 21.734375 C 62.644531 21.839844 63.078125 21.464844 63.230469 20.902344 Z M 63.230469 20.902344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 68.859375 22.507812 C 69.011719 21.945312 68.824219 21.40625 68.441406 21.300781 C 68.058594 21.199219 67.628906 21.574219 67.476562 22.136719 C 67.324219 22.699219 67.507812 23.238281 67.890625 23.34375 C 68.273438 23.445312 68.707031 23.074219 68.859375 22.507812 Z M 68.859375 22.507812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 61.804688 17.996094 L 64.667969 18.816406 C 64.71875 18.828125 64.769531 18.816406 64.8125 18.792969 C 64.859375 18.765625 64.890625 18.726562 64.90625 18.679688 C 64.921875 18.589844 64.914062 18.496094 64.890625 18.410156 C 64.867188 18.320312 64.828125 18.238281 64.769531 18.167969 C 64.714844 18.09375 64.644531 18.035156 64.566406 17.992188 C 64.484375 17.945312 64.398438 17.917969 64.304688 17.910156 L 61.847656 17.652344 C 61.660156 17.601562 61.570312 17.929688 61.804688 17.996094 Z M 61.804688 17.996094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 71.59375 20.4375 L 67.710938 19.644531 C 67.746094 19.527344 67.804688 19.421875 67.882812 19.332031 C 67.964844 19.238281 68.058594 19.164062 68.167969 19.113281 C 68.277344 19.0625 68.398438 19.035156 68.515625 19.03125 C 68.636719 19.027344 68.757812 19.050781 68.871094 19.097656 L 71.703125 20.214844 C 71.796875 20.242188 71.734375 20.476562 71.59375 20.4375 Z M 71.59375 20.4375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2.23881,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      stroke: "rgb(89.803922%,39.215686%,25.490196%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 129.921875 42.125 L 126.242188 47.085938 L 127.632812 49.046875 ",
    transform: "matrix(0.5,0,0,0.5,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 68.382812 47.5 C 68.742188 47.5 69.75 47.296875 69.75 46.3125 C 69.75 45.328125 68.742188 44.53125 68.382812 44.53125 C 68.027344 44.53125 67 45.328125 67 46.3125 C 67 47.296875 68.027344 47.5 68.382812 47.5 Z M 68.382812 47.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,70.196078%)",
      fillOpacity: 1
    },
    d: "M 98.132812 72.613281 L 88.5625 73.398438 L 86.929688 66.46875 L 84.960938 61.136719 L 95.03125 59.929688 L 96.292969 65.898438 Z M 98.132812 72.613281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,58.823529%,48.627451%)",
      fillOpacity: 1
    },
    d: "M 95.375 61.539062 L 95.726562 63.214844 L 85.808594 63.425781 L 85.15625 61.660156 Z M 95.375 61.539062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(4.313725%,13.333333%,36.078431%)",
      fillOpacity: 1
    },
    d: "M 87.527344 53.820312 C 91.183594 53.820312 94.152344 50.855469 94.152344 47.199219 C 94.152344 43.546875 91.183594 40.582031 87.527344 40.582031 C 83.871094 40.582031 80.90625 43.546875 80.90625 47.199219 C 80.90625 50.855469 83.871094 53.820312 87.527344 53.820312 Z M 87.527344 53.820312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(4.313725%,13.333333%,36.078431%)",
      fillOpacity: 1
    },
    d: "M 86.25 44.089844 C 86.25 44.089844 93.226562 42.945312 93.820312 45.171875 C 95.101562 49.652344 96.675781 56.839844 97.058594 60.28125 C 97.070312 60.425781 97.054688 60.574219 97.011719 60.714844 C 96.964844 60.851562 96.894531 60.984375 96.800781 61.09375 C 96.707031 61.207031 96.589844 61.300781 96.460938 61.367188 C 96.328125 61.433594 96.183594 61.472656 96.039062 61.484375 L 85.527344 62.382812 C 85.121094 62.421875 84.714844 62.300781 84.394531 62.050781 C 84.074219 61.796875 83.859375 61.429688 83.800781 61.027344 L 80.953125 48.144531 Z M 86.25 44.089844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 65.78125 12.554688 C 65.78125 12.554688 66.027344 17.015625 69.8125 19.179688 C 69.8125 19.179688 70.917969 22.601562 75.046875 23.40625 C 75.046875 23.40625 74.800781 20.257812 76.769531 20.292969 C 80.109375 20.347656 78.464844 25.414062 76.207031 26.246094 C 74.671875 26.808594 70.503906 38.1875 82.253906 34 C 87.484375 32.136719 84.9375 23.984375 83.496094 15.628906 C 82.339844 8.9375 74.039062 6.75 72.332031 6.96875 C 72.332031 6.96875 65.25 4.523438 61.519531 11.230469 C 58.332031 16.964844 61.308594 20.386719 61.308594 20.386719 L 63.007812 15.28125 C 63.007812 15.28125 63.71875 15.78125 65.78125 12.554688 Z M 65.78125 12.554688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 98.167969 89.148438 L 72.820312 89.148438 C 72.328125 89.148438 71.855469 88.96875 71.488281 88.644531 C 71.121094 88.320312 70.886719 87.875 70.824219 87.386719 L 68.484375 68.726562 C 68.449219 68.441406 68.472656 68.15625 68.558594 67.882812 C 68.640625 67.609375 68.785156 67.359375 68.972656 67.144531 C 69.160156 66.929688 69.394531 66.761719 69.652344 66.644531 C 69.914062 66.527344 70.195312 66.464844 70.480469 66.464844 L 100.507812 66.464844 C 100.792969 66.464844 101.074219 66.527344 101.335938 66.644531 C 101.597656 66.761719 101.828125 66.929688 102.015625 67.144531 C 102.207031 67.359375 102.347656 67.609375 102.429688 67.882812 C 102.515625 68.15625 102.539062 68.441406 102.503906 68.726562 L 100.164062 87.386719 C 100.105469 87.875 99.867188 88.320312 99.5 88.644531 C 99.132812 88.96875 98.660156 89.148438 98.167969 89.148438 Z M 98.167969 89.148438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 85.550781 79.238281 C 86.535156 79.238281 87.332031 78.445312 87.332031 77.460938 C 87.332031 76.480469 86.535156 75.683594 85.550781 75.683594 C 84.570312 75.683594 83.773438 76.480469 83.773438 77.460938 C 83.773438 78.445312 84.570312 79.238281 85.550781 79.238281 Z M 85.550781 79.238281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,70.196078%)",
      fillOpacity: 1
    },
    d: "M 27.222656 40.667969 L 25.695312 37.742188 C 25.695312 37.742188 20.296875 34.652344 19.667969 33.535156 C 19.042969 32.417969 18.796875 29.230469 19.90625 28.414062 C 19.90625 28.414062 15.597656 25.179688 16.332031 24.527344 C 17.0625 23.824219 25.527344 30.109375 25.527344 30.109375 C 25.527344 30.109375 24.496094 25.476562 26.0625 25.261719 C 26.488281 27.054688 27.214844 28.765625 28.214844 30.316406 C 29.863281 32.863281 30.066406 35.148438 30.066406 35.148438 L 32.007812 38.875 Z M 27.222656 40.667969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2.87188,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(100%,58.823529%,48.627451%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 40.390625 56.992188 L 45.609375 60.28125 ",
    transform: "matrix(0.5,0,0,0.5,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2.87188,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(100%,58.823529%,48.627451%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 39.609375 60.75 L 44.039062 63.507812 ",
    transform: "matrix(0.5,0,0,0.5,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2.87188,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(100%,58.823529%,48.627451%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 40.476562 64.8125 L 43.429688 66.679688 ",
    transform: "matrix(0.5,0,0,0.5,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 30.402344 6.378906 C 31.089844 6.378906 31.648438 5.824219 31.648438 5.136719 C 31.648438 4.449219 31.089844 3.894531 30.402344 3.894531 C 29.71875 3.894531 29.160156 4.449219 29.160156 5.136719 C 29.160156 5.824219 29.71875 6.378906 30.402344 6.378906 Z M 30.402344 6.378906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 35.425781 6.378906 C 36.113281 6.378906 36.671875 5.824219 36.671875 5.136719 C 36.671875 4.449219 36.113281 3.894531 35.425781 3.894531 C 34.742188 3.894531 34.183594 4.449219 34.183594 5.136719 C 34.183594 5.824219 34.742188 6.378906 35.425781 6.378906 Z M 35.425781 6.378906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 40.148438 6.378906 C 40.835938 6.378906 41.394531 5.824219 41.394531 5.136719 C 41.394531 4.449219 40.835938 3.894531 40.148438 3.894531 C 39.464844 3.894531 38.90625 4.449219 38.90625 5.136719 C 38.90625 5.824219 39.464844 6.378906 40.148438 6.378906 Z M 40.148438 6.378906 "
  }), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface5",
    mask: "url(#mask0)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 9.367188 25.609375 C 9.367188 25.609375 17.257812 33.273438 28.046875 38.03125 ",
    transform: "matrix(0.5,0,0,0.5,0,0)"
  }), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface8",
    mask: "url(#mask1)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 3.867188 34.4375 L 3.867188 23.355469 L 7.753906 26.136719 L 7.753906 37.484375 Z M 3.867188 34.4375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 10.425781 38.914062 L 10.425781 31.023438 L 14.3125 33.34375 L 14.3125 41.148438 Z M 10.425781 38.914062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 27.042969 45.089844 L 27.042969 37.199219 L 23.15625 36.664062 L 23.15625 44.46875 Z M 27.042969 45.089844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 33.425781 45.429688 L 33.425781 31.609375 L 29.539062 31.609375 L 29.539062 45.339844 Z M 33.425781 45.429688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 16.789062 42.371094 L 16.789062 38.761719 L 20.675781 39.855469 L 20.675781 43.777344 Z M 16.789062 42.371094 "
  }), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface14",
    mask: "url(#mask2)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80%,70.196078%)",
      fillOpacity: 1
    },
    d: "M 93.007812 88.386719 C 93.007812 88.386719 94.347656 88.5 94.144531 89.175781 C 93.945312 89.851562 92.746094 89.539062 91.65625 90.214844 C 90.5625 90.890625 86.246094 91.371094 84.089844 91.011719 C 81.933594 90.652344 81.332031 88.386719 81.332031 88.386719 C 81.332031 88.386719 80.972656 86.238281 84.78125 86.019531 C 88.59375 85.796875 90.363281 87.019531 91.027344 88.34375 Z M 93.007812 88.386719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2.23881,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      stroke: "rgb(89.803922%,39.215686%,25.490196%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 165.90625 172.703125 L 167.554688 177.125 ",
    transform: "matrix(0.5,0,0,0.5,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2.23881,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      stroke: "rgb(89.803922%,39.215686%,25.490196%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 170.164062 171.984375 L 171.8125 176.40625 ",
    transform: "matrix(0.5,0,0,0.5,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2.23881,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      stroke: "rgb(89.803922%,39.215686%,25.490196%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 174.671875 172.359375 L 176.320312 176.789062 ",
    transform: "matrix(0.5,0,0,0.5,0,0)"
  }), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface17",
    mask: "url(#mask4)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 261.804688 146.015625 C 261.804688 146.015625 250.796875 156.703125 235.75 163.34375 ",
    transform: "matrix(0.5,0,0,0.5,0,0)"
  }), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface20",
    mask: "url(#mask5)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(5.490196%,6.27451%,15.294118%)",
      fillOpacity: 1
    },
    d: "M 127.324219 50.402344 L 106.03125 50.402344 C 105.613281 50.402344 105.199219 50.484375 104.816406 50.640625 C 104.429688 50.800781 104.078125 51.035156 103.78125 51.332031 C 103.488281 51.628906 103.253906 51.976562 103.09375 52.363281 C 102.933594 52.75 102.851562 53.160156 102.851562 53.578125 L 102.851562 60.164062 C 102.851562 60.582031 102.933594 60.996094 103.09375 61.378906 C 103.253906 61.765625 103.488281 62.117188 103.78125 62.410156 C 104.078125 62.707031 104.429688 62.941406 104.816406 63.101562 C 105.199219 63.261719 105.613281 63.34375 106.03125 63.34375 L 113.59375 63.34375 L 115.820312 65.570312 C 116.03125 65.78125 116.3125 65.898438 116.609375 65.898438 C 116.90625 65.898438 117.1875 65.78125 117.398438 65.570312 L 119.625 63.34375 L 127.324219 63.34375 C 128.167969 63.34375 128.980469 63.007812 129.574219 62.410156 C 130.171875 61.816406 130.507812 61.007812 130.507812 60.164062 L 130.507812 53.578125 C 130.507812 52.738281 130.171875 51.929688 129.574219 51.332031 C 128.980469 50.734375 128.167969 50.402344 127.324219 50.402344 Z M 127.324219 50.402344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,0%,41.960784%)",
      fillOpacity: 1
    },
    d: "M 111.882812 54.78125 C 111.597656 54.519531 111.226562 54.371094 110.839844 54.371094 C 110.453125 54.371094 110.078125 54.519531 109.796875 54.78125 L 109.402344 55.144531 L 109.007812 54.78125 C 108.726562 54.519531 108.351562 54.371094 107.964844 54.371094 C 107.578125 54.371094 107.207031 54.519531 106.921875 54.78125 C 106.773438 54.917969 106.652344 55.082031 106.570312 55.265625 C 106.488281 55.453125 106.445312 55.652344 106.445312 55.855469 C 106.445312 56.058594 106.488281 56.257812 106.570312 56.441406 C 106.652344 56.625 106.773438 56.792969 106.921875 56.929688 L 109.402344 59.226562 L 111.882812 56.957031 C 112.039062 56.824219 112.164062 56.65625 112.25 56.46875 C 112.339844 56.28125 112.382812 56.078125 112.382812 55.871094 C 112.382812 55.664062 112.339844 55.460938 112.25 55.269531 C 112.164062 55.082031 112.039062 54.914062 111.882812 54.78125 Z M 111.882812 54.78125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 114.65625 56.125 C 114.675781 55.847656 114.785156 55.628906 114.976562 55.46875 C 115.171875 55.3125 115.421875 55.234375 115.730469 55.234375 C 115.9375 55.234375 116.117188 55.273438 116.261719 55.347656 C 116.414062 55.421875 116.53125 55.519531 116.605469 55.648438 C 116.683594 55.773438 116.722656 55.917969 116.722656 56.078125 C 116.722656 56.265625 116.667969 56.429688 116.558594 56.566406 C 116.453125 56.699219 116.3125 56.789062 116.140625 56.828125 L 116.140625 56.851562 C 116.335938 56.898438 116.492188 56.996094 116.609375 57.136719 C 116.722656 57.277344 116.78125 57.464844 116.78125 57.695312 C 116.78125 57.867188 116.742188 58.023438 116.664062 58.164062 C 116.585938 58.300781 116.46875 58.40625 116.308594 58.484375 C 116.152344 58.5625 115.960938 58.601562 115.742188 58.601562 C 115.421875 58.601562 115.15625 58.519531 114.949219 58.355469 C 114.746094 58.183594 114.628906 57.945312 114.605469 57.636719 L 115.003906 57.636719 C 115.027344 57.816406 115.101562 57.964844 115.226562 58.082031 C 115.355469 58.195312 115.527344 58.253906 115.738281 58.253906 C 115.949219 58.253906 116.109375 58.199219 116.21875 58.089844 C 116.332031 57.976562 116.386719 57.835938 116.386719 57.660156 C 116.386719 57.433594 116.308594 57.269531 116.160156 57.167969 C 116.007812 57.070312 115.777344 57.019531 115.472656 57.019531 L 115.367188 57.019531 L 115.367188 56.671875 L 115.476562 56.671875 C 115.757812 56.671875 115.96875 56.625 116.109375 56.539062 C 116.253906 56.445312 116.324219 56.308594 116.324219 56.121094 C 116.324219 55.960938 116.269531 55.832031 116.164062 55.734375 C 116.0625 55.636719 115.914062 55.589844 115.71875 55.589844 C 115.53125 55.589844 115.378906 55.636719 115.265625 55.734375 C 115.148438 55.832031 115.082031 55.960938 115.058594 56.125 Z M 117.835938 58.007812 L 117.328125 59.230469 L 117.050781 59.230469 L 117.382812 58.007812 Z M 120.335938 55.65625 L 118.742188 55.65625 L 118.742188 56.691406 C 118.808594 56.59375 118.914062 56.515625 119.050781 56.457031 C 119.183594 56.390625 119.332031 56.359375 119.488281 56.359375 C 119.742188 56.359375 119.945312 56.414062 120.101562 56.519531 C 120.261719 56.621094 120.371094 56.757812 120.441406 56.921875 C 120.507812 57.085938 120.542969 57.261719 120.542969 57.445312 C 120.542969 57.664062 120.503906 57.859375 120.421875 58.03125 C 120.339844 58.203125 120.214844 58.339844 120.042969 58.441406 C 119.878906 58.539062 119.671875 58.589844 119.421875 58.589844 C 119.105469 58.589844 118.847656 58.507812 118.648438 58.34375 C 118.453125 58.179688 118.332031 57.964844 118.289062 57.691406 L 118.695312 57.691406 C 118.734375 57.863281 118.816406 57.996094 118.945312 58.09375 C 119.070312 58.191406 119.234375 58.238281 119.425781 58.238281 C 119.664062 58.238281 119.84375 58.167969 119.96875 58.027344 C 120.089844 57.882812 120.148438 57.691406 120.148438 57.453125 C 120.148438 57.21875 120.089844 57.035156 119.96875 56.910156 C 119.84375 56.78125 119.667969 56.714844 119.429688 56.714844 C 119.269531 56.714844 119.128906 56.753906 119.007812 56.832031 C 118.890625 56.910156 118.804688 57.011719 118.75 57.144531 L 118.359375 57.144531 L 118.359375 55.292969 L 120.335938 55.292969 Z M 121.042969 58.25 C 121.429688 57.941406 121.730469 57.6875 121.945312 57.492188 C 122.164062 57.292969 122.347656 57.085938 122.496094 56.867188 C 122.648438 56.652344 122.726562 56.4375 122.726562 56.226562 C 122.726562 56.03125 122.675781 55.878906 122.578125 55.765625 C 122.484375 55.652344 122.332031 55.59375 122.121094 55.59375 C 121.914062 55.59375 121.753906 55.65625 121.636719 55.789062 C 121.527344 55.914062 121.464844 56.085938 121.457031 56.300781 L 121.058594 56.300781 C 121.070312 55.960938 121.171875 55.699219 121.367188 55.515625 C 121.558594 55.332031 121.808594 55.238281 122.117188 55.238281 C 122.425781 55.238281 122.675781 55.324219 122.855469 55.496094 C 123.039062 55.671875 123.132812 55.90625 123.132812 56.210938 C 123.132812 56.460938 123.058594 56.707031 122.90625 56.945312 C 122.757812 57.183594 122.589844 57.390625 122.398438 57.574219 C 122.207031 57.75 121.960938 57.960938 121.664062 58.199219 L 123.226562 58.199219 L 123.226562 58.542969 L 121.042969 58.542969 Z M 125.726562 55.621094 L 124.464844 58.582031 L 124.046875 58.582031 L 125.328125 55.660156 L 123.574219 55.660156 L 123.574219 55.308594 L 125.726562 55.308594 Z M 125.726562 55.621094 "
  }), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface23",
    mask: "url(#mask6)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 9.960938 107.335938 C 10.25 107.105469 10.476562 106.914062 10.644531 106.765625 C 10.808594 106.613281 10.945312 106.457031 11.058594 106.296875 C 11.171875 106.132812 11.226562 105.972656 11.226562 105.8125 C 11.226562 105.664062 11.191406 105.550781 11.117188 105.464844 C 11.046875 105.378906 10.933594 105.335938 10.773438 105.335938 C 10.617188 105.335938 10.496094 105.382812 10.410156 105.480469 C 10.324219 105.578125 10.28125 105.707031 10.273438 105.867188 L 9.972656 105.867188 C 9.980469 105.613281 10.058594 105.414062 10.203125 105.277344 C 10.351562 105.136719 10.539062 105.066406 10.769531 105.066406 C 11.003906 105.066406 11.191406 105.132812 11.328125 105.261719 C 11.46875 105.390625 11.535156 105.570312 11.535156 105.800781 C 11.535156 105.988281 11.480469 106.175781 11.367188 106.355469 C 11.253906 106.53125 11.125 106.691406 10.980469 106.828125 C 10.835938 106.960938 10.652344 107.117188 10.429688 107.300781 L 11.609375 107.300781 L 11.609375 107.558594 L 9.960938 107.558594 Z M 11.894531 107.035156 L 11.894531 106.800781 L 13.097656 105.136719 L 13.46875 105.136719 L 13.46875 106.765625 L 13.8125 106.765625 L 13.8125 107.035156 L 13.46875 107.035156 L 13.46875 107.585938 L 13.160156 107.585938 L 13.160156 107.035156 Z M 13.175781 105.460938 L 12.253906 106.765625 L 13.175781 106.765625 Z M 14.117188 105.734375 C 14.132812 105.523438 14.214844 105.359375 14.359375 105.242188 C 14.503906 105.125 14.695312 105.0625 14.929688 105.0625 C 15.082031 105.0625 15.21875 105.09375 15.328125 105.148438 C 15.441406 105.203125 15.527344 105.28125 15.585938 105.375 C 15.644531 105.472656 15.675781 105.578125 15.675781 105.699219 C 15.675781 105.84375 15.632812 105.964844 15.550781 106.066406 C 15.472656 106.167969 15.367188 106.234375 15.238281 106.265625 L 15.238281 106.28125 C 15.386719 106.320312 15.503906 106.390625 15.589844 106.5 C 15.675781 106.605469 15.71875 106.746094 15.71875 106.917969 C 15.71875 107.050781 15.691406 107.167969 15.628906 107.273438 C 15.570312 107.375 15.480469 107.457031 15.363281 107.515625 C 15.246094 107.574219 15.101562 107.605469 14.933594 107.605469 C 14.691406 107.605469 14.492188 107.542969 14.339844 107.414062 C 14.183594 107.289062 14.097656 107.109375 14.078125 106.875 L 14.378906 106.875 C 14.394531 107.011719 14.453125 107.125 14.546875 107.210938 C 14.644531 107.296875 14.773438 107.339844 14.929688 107.339844 C 15.089844 107.339844 15.210938 107.300781 15.292969 107.21875 C 15.378906 107.132812 15.421875 107.023438 15.421875 106.890625 C 15.421875 106.722656 15.363281 106.597656 15.25 106.523438 C 15.136719 106.445312 14.964844 106.410156 14.734375 106.410156 L 14.652344 106.410156 L 14.652344 106.148438 L 14.734375 106.148438 C 14.945312 106.148438 15.105469 106.113281 15.210938 106.046875 C 15.320312 105.976562 15.375 105.871094 15.375 105.730469 C 15.375 105.609375 15.332031 105.511719 15.253906 105.441406 C 15.175781 105.367188 15.0625 105.332031 14.917969 105.332031 C 14.777344 105.332031 14.660156 105.367188 14.574219 105.441406 C 14.488281 105.511719 14.4375 105.613281 14.421875 105.734375 Z M 17.519531 105.699219 C 17.46875 105.449219 17.3125 105.320312 17.050781 105.320312 C 16.847656 105.320312 16.695312 105.398438 16.597656 105.558594 C 16.496094 105.710938 16.445312 105.96875 16.449219 106.328125 C 16.5 106.207031 16.585938 106.117188 16.707031 106.050781 C 16.832031 105.980469 16.96875 105.945312 17.121094 105.945312 C 17.355469 105.945312 17.542969 106.019531 17.679688 106.167969 C 17.824219 106.3125 17.894531 106.515625 17.894531 106.773438 C 17.894531 106.925781 17.863281 107.066406 17.800781 107.191406 C 17.742188 107.3125 17.652344 107.410156 17.527344 107.484375 C 17.40625 107.558594 17.257812 107.59375 17.085938 107.59375 C 16.851562 107.59375 16.667969 107.542969 16.535156 107.4375 C 16.402344 107.332031 16.308594 107.1875 16.257812 107 C 16.203125 106.816406 16.179688 106.589844 16.179688 106.316406 C 16.179688 105.480469 16.46875 105.058594 17.054688 105.058594 C 17.277344 105.058594 17.453125 105.121094 17.582031 105.242188 C 17.710938 105.363281 17.785156 105.515625 17.808594 105.699219 Z M 17.054688 106.210938 C 16.957031 106.210938 16.863281 106.230469 16.777344 106.273438 C 16.691406 106.3125 16.621094 106.371094 16.566406 106.453125 C 16.511719 106.535156 16.484375 106.632812 16.484375 106.75 C 16.484375 106.921875 16.535156 107.0625 16.636719 107.171875 C 16.738281 107.28125 16.882812 107.335938 17.070312 107.335938 C 17.226562 107.335938 17.355469 107.285156 17.449219 107.1875 C 17.542969 107.085938 17.59375 106.953125 17.59375 106.78125 C 17.59375 106.605469 17.546875 106.464844 17.457031 106.363281 C 17.363281 106.261719 17.230469 106.210938 17.054688 106.210938 Z M 17.054688 106.210938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 175.6875 213.734375 C 175.6875 213.734375 185.929688 211.59375 190.609375 206.625 C 196.8125 200.054688 198.242188 192.164062 205.039062 191.351562 C 215.703125 190.078125 221.882812 227.710938 234.835938 222.617188 C 247.78125 217.53125 244.726562 189.429688 252.429688 184.664062 C 257.734375 181.382812 260.492188 191.140625 267.921875 188.59375 ",
    transform: "matrix(0.5,0,0,0.5,0,0)"
  }), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface26",
    mask: "url(#mask7)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 3.132812 108.089844 L 3.660156 108.089844 C 3.757812 108.089844 3.851562 108.050781 3.921875 107.980469 C 3.988281 107.914062 4.027344 107.820312 4.027344 107.722656 L 4.027344 105.304688 C 4.027344 105.207031 3.988281 105.113281 3.921875 105.042969 C 3.851562 104.972656 3.757812 104.933594 3.660156 104.933594 L 3.132812 104.933594 C 3.035156 104.933594 2.941406 104.972656 2.875 105.042969 C 2.804688 105.113281 2.765625 105.207031 2.765625 105.304688 L 2.765625 107.722656 C 2.765625 107.820312 2.804688 107.914062 2.875 107.980469 C 2.941406 108.050781 3.035156 108.089844 3.132812 108.089844 Z M 3.132812 108.089844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 5.453125 103.410156 C 5.246094 103.410156 5.140625 103.515625 5.140625 104.039062 C 5.140625 104.539062 4.65625 104.941406 4.34375 105.148438 L 4.34375 107.753906 C 4.679688 107.910156 5.355469 108.140625 6.402344 108.140625 L 6.738281 108.140625 C 6.9375 108.140625 7.128906 108.070312 7.28125 107.945312 C 7.433594 107.816406 7.535156 107.636719 7.566406 107.441406 L 7.800781 106.078125 C 7.824219 105.957031 7.816406 105.832031 7.785156 105.714844 C 7.753906 105.59375 7.695312 105.484375 7.617188 105.390625 C 7.539062 105.296875 7.441406 105.222656 7.328125 105.171875 C 7.21875 105.117188 7.097656 105.09375 6.972656 105.09375 L 5.980469 105.09375 C 6.09375 104.828125 6.144531 104.539062 6.136719 104.25 C 6.136719 103.621094 5.664062 103.410156 5.453125 103.410156 Z M 5.453125 103.410156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 20.660156 86.78125 C 17.867188 85.800781 15.605469 82.742188 15.605469 79.953125 C 15.605469 77.164062 17.867188 75.699219 20.660156 76.683594 L 20.660156 73.441406 C 16.152344 71.851562 12.496094 74.21875 12.496094 78.722656 C 12.496094 83.226562 16.152344 88.167969 20.660156 89.757812 C 24.976562 91.277344 28.507812 89.171875 28.800781 85.035156 L 25.691406 83.9375 C 25.472656 86.449219 23.304688 87.714844 20.660156 86.78125 Z M 20.660156 86.78125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,0%,41.960784%)",
      fillOpacity: 1
    },
    d: "M 21.695312 72.769531 L 21.695312 76.011719 C 24.484375 76.992188 26.746094 80.050781 26.746094 82.839844 C 26.746094 82.988281 26.742188 83.128906 26.726562 83.265625 L 29.835938 84.363281 C 29.847656 84.179688 29.859375 83.992188 29.859375 83.804688 C 29.859375 79.296875 26.203125 74.359375 21.695312 72.769531 Z M 21.695312 72.769531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2.42819,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 41.3125 173.5625 L 41.3125 179.515625 ",
    transform: "matrix(0.5,0,0,0.5,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2.42819,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 31.210938 159.90625 L 24.992188 157.710938 ",
    transform: "matrix(0.5,0,0,0.5,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 67.5 160.828125 L 79.039062 163.023438 ",
    transform: "matrix(0.5,0,0,0.5,0,0)"
  }), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface29",
    mask: "url(#mask8)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 67.5 170.046875 L 84.078125 173.195312 ",
    transform: "matrix(0.5,0,0,0.5,0,0)"
  }), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface35",
    mask: "url(#mask9)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 104.25 23.394531 L 104.25 39.042969 C 104.25 39.179688 104.28125 39.3125 104.339844 39.4375 C 104.398438 39.558594 104.484375 39.667969 104.589844 39.753906 C 104.695312 39.835938 104.820312 39.898438 104.953125 39.929688 C 105.085938 39.960938 105.222656 39.960938 105.359375 39.929688 C 108.210938 39.292969 115.921875 37.445312 120.796875 35.148438 C 120.953125 35.074219 121.082031 34.960938 121.175781 34.8125 C 121.265625 34.667969 121.316406 34.5 121.3125 34.328125 L 121.3125 19.089844 C 121.316406 18.9375 121.277344 18.785156 121.203125 18.652344 C 121.128906 18.519531 121.027344 18.40625 120.894531 18.324219 C 120.769531 18.242188 120.621094 18.191406 120.46875 18.183594 C 120.316406 18.171875 120.164062 18.199219 120.027344 18.261719 C 117.3125 19.511719 110.789062 22.242188 105.113281 22.488281 C 104.878906 22.5 104.660156 22.597656 104.5 22.769531 C 104.339844 22.9375 104.25 23.160156 104.25 23.394531 Z M 104.25 23.394531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(4.313725%,13.333333%,36.078431%)",
      fillOpacity: 1
    },
    d: "M 104.953125 36.527344 L 104.953125 38.171875 C 104.953125 38.296875 104.980469 38.421875 105.035156 38.53125 C 105.09375 38.644531 105.171875 38.742188 105.273438 38.816406 C 105.371094 38.890625 105.484375 38.945312 105.609375 38.96875 C 105.730469 38.992188 105.855469 38.988281 105.976562 38.953125 L 114.511719 36.621094 C 114.644531 36.585938 114.769531 36.515625 114.867188 36.417969 C 114.96875 36.320312 115.039062 36.195312 115.078125 36.0625 C 115.113281 35.929688 115.117188 35.789062 115.085938 35.652344 C 115.050781 35.515625 114.984375 35.390625 114.890625 35.289062 L 110.316406 30.371094 C 110.234375 30.28125 110.132812 30.210938 110.023438 30.167969 C 109.910156 30.125 109.789062 30.105469 109.667969 30.113281 C 109.546875 30.121094 109.429688 30.15625 109.324219 30.214844 C 109.21875 30.273438 109.128906 30.355469 109.058594 30.453125 L 105.101562 36.058594 C 105.003906 36.195312 104.953125 36.359375 104.953125 36.527344 Z M 104.953125 36.527344 "
  }), _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface38",
    mask: "url(#mask11)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,0%,41.960784%)",
      fillOpacity: 1
    },
    d: "M 111.40625 28.421875 C 112.164062 28.421875 112.78125 27.808594 112.78125 27.050781 C 112.78125 26.289062 112.164062 25.675781 111.40625 25.675781 C 110.648438 25.675781 110.03125 26.289062 110.03125 27.050781 C 110.03125 27.808594 110.648438 28.421875 111.40625 28.421875 Z M 111.40625 28.421875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 250.5625 35.507812 C 257.617188 31.929688 264.40625 27.851562 270.882812 23.3125 ",
    transform: "matrix(0.5,0,0,0.5,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 250.5625 47.375 C 250.5625 47.375 255.1875 45.125 261.53125 41.273438 ",
    transform: "matrix(0.5,0,0,0.5,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 250.5625 58.984375 C 257.617188 55.40625 264.40625 51.328125 270.882812 46.78125 ",
    transform: "matrix(0.5,0,0,0.5,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 250.5625 72.007812 C 257.617188 68.429688 264.40625 64.351562 270.882812 59.8125 ",
    transform: "matrix(0.5,0,0,0.5,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 106.207031 44.441406 C 106.902344 44.441406 107.464844 43.878906 107.464844 43.1875 C 107.464844 42.492188 106.902344 41.933594 106.207031 41.933594 C 105.515625 41.933594 104.953125 42.492188 104.953125 43.1875 C 104.953125 43.878906 105.515625 44.441406 106.207031 44.441406 Z M 106.207031 44.441406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 113.492188 42.410156 C 114.1875 42.410156 114.75 41.851562 114.75 41.15625 C 114.75 40.464844 114.1875 39.902344 113.492188 39.902344 C 112.800781 39.902344 112.238281 40.464844 112.238281 41.15625 C 112.238281 41.851562 112.800781 42.410156 113.492188 42.410156 Z M 113.492188 42.410156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 120.058594 40.171875 C 120.753906 40.171875 121.316406 39.609375 121.316406 38.917969 C 121.316406 38.222656 120.753906 37.660156 120.058594 37.660156 C 119.367188 37.660156 118.804688 38.222656 118.804688 38.917969 C 118.804688 39.609375 119.367188 40.171875 120.058594 40.171875 Z M 120.058594 40.171875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(50.588235%,50.588235%,50.588235%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(50.588235%,50.588235%,50.588235%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 155 47 L 155.5 46 L 158 47.5 L 157.5 48.5 Z M 155 47 ",
    transform: "matrix(0.5,0,0,0.5,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(50.588235%,50.588235%,50.588235%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(50.588235%,50.588235%,50.588235%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 153.0625 49.703125 C 152.984375 49.546875 152.921875 49.1875 153.296875 49 C 153.53125 49 153.765625 49 154 49.234375 L 154 49.703125 L 153.765625 49.9375 C 153.609375 50.015625 153.25 50.078125 153.0625 49.703125 Z M 153.0625 49.703125 ",
    transform: "matrix(0.5,0,0,0.5,0,0)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeVetor);
export default __webpack_public_path__ + "static/media/welcomeVetor.8aa4a546f27a82da6d516e0ae81880cd.svg";
export { ForwardRef as ReactComponent };